import {
  useBoolean,
  useToastr,
} from '@laxmimanogna/code-quick-components';
import React, { createContext, useState } from 'react';
import auditSheetRepository from '../repositories/AuditSheetRepository';
import notificationRepository from '../repositories/NotificationRepository';

export const NotificationsContext = createContext({
  // async func
  getNotifications: async () => { },
  changeNotificationStatus: async notificationId => { },
  markUnread: async notificationId => { },
  markAllRead: async () => { },
  loadNewNotification: () => { },

  // state
  notifications: [],
  unReadNotification: 0,
  notificationCount: 0,

  // boolean
  isFetchingNotifications: false,
  getAuditUpload: async () => { },
  setNotifications: () => { },
  setUnReadNotification: () => { },
  setNotificationCount: () => { },
});

function NotificationProvider(props) {
  const toast = useToastr();

  const [notifications, setNotifications] = useState([]);
  const [unReadNotification, setUnReadNotification] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isFetchingNotifications, ifnState] = useBoolean(false);

  const getNotifications = async (currentPage, readFilter) => {
    try {
      ifnState.on();
      const response = await notificationRepository.getNotifications(
        currentPage,
        readFilter
      );
      setNotifications(response.results);
      setUnReadNotification(response?.unread_count);
      setNotificationCount(response.count);
      return response;
    } catch (err) {
      toast.showError({
        description: `${err.toString()}`,
      });
    } finally {
      ifnState.off();
    }
  };

  const changeNotificationStatus = async notificationId => {
    try {
      const response = await notificationRepository.changeNotificationStatus(
        notificationId
      );
      setUnReadNotification(prev => Math.max(0, prev - 1));
      return response;
    } catch (err) {
      toast.showError({
        description: `${err.toString()}`,
      });
    }
  };

  const markUnread = async notificationId => {
    try {
      const response = await notificationRepository.markUnread(notificationId);
      setUnReadNotification(prev => prev + 1);
      return response;
    } catch (err) {
      toast.showError({ description: `${err.toString()}` });
    }
  };

  const markAllRead = async () => {
    try {
      await notificationRepository.markAllRead();
      setUnReadNotification(0);
    } catch (err) {
      toast.showError({
        description: `${err.toString()}`,
      });
    }
  };

  async function getAuditUpload(uploadId) {
    try {
      await auditSheetRepository.getAuditUpload(uploadId);
      return true;
    } catch (err) {
      return false;
    }
  }

  const loadNewNotification = async () => {
    try {
      const response = await notificationRepository.getNotifications(1);
      return response;
    } catch (err) {
      toast.showError({
        description: `${err.toString()}`,
      });
    }
  };

  const mContext = {
    getNotifications,
    notifications,
    unReadNotification,
    notificationCount,
    isFetchingNotifications,
    changeNotificationStatus,
    markUnread,
    markAllRead,
    getAuditUpload,
    loadNewNotification,
    setNotifications,
    setUnReadNotification,
    setNotificationCount,
  };

  return (
    <NotificationsContext.Provider value={mContext}>
      {props.children}
    </NotificationsContext.Provider>
  );
}

export default NotificationProvider;
